import { render } from "./Leave.vue?vue&type=template&id=d0670f68"
import script from "./Leave.vue?vue&type=script&lang=js"
export * from "./Leave.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__